import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import { EventAttributeTypesValues, IAttributesDAO, IEventAttributeDAO, IEventAttributeDetailsDTO, IEventAttributeRequestDAO, TGetEventAttributesSortKeys } from '../attributes.dao';
import { CREATE_EVENT_ATTRIBUTE_URL, GET_EVENT_ATTRIBUTES_LIST_URL, GET_EVENT_ATTRIBUTE_DETAILS_URL } from '../../constants/api/attributes.constants';
import { ISortRequestParams, replaceSortRequestParamsWithSortString } from '../shared.dto';

class AttributesDAO extends IAttributesDAO {
    constructor(
        @IoC.Inject private readonly apiClient: IApiClient
    ) {
        super();
    }

    public async getEventAttributesList(
        params: { accountId: number; inputTypes?: EventAttributeTypesValues[] } & ISortRequestParams<TGetEventAttributesSortKeys>
    ): Promise<IEventAttributeDAO> {
        const { inputTypes, ...rest } = params;
        const paramsWithSortString = replaceSortRequestParamsWithSortString(rest);
        const filterParamsString = this.replaceFilterRequestParamsWithString(paramsWithSortString, inputTypes);
        const response = await this.apiClient.get<IEventAttributeDAO>( GET_EVENT_ATTRIBUTES_LIST_URL, filterParamsString);
        return response.parsedResponse;
    }

    public async createEventAttribute(params: IEventAttributeRequestDAO): Promise<IEventAttributeDetailsDTO> {
        const response = await this.apiClient.post<IEventAttributeDetailsDTO>(CREATE_EVENT_ATTRIBUTE_URL, params);
        return response.parsedResponse;
    }

    public async getEventAttributeDetails(params: { accountId: number; eventAttributeId: number }): Promise<IEventAttributeDetailsDTO> {
        const response = await this.apiClient.get<IEventAttributeDetailsDTO>(GET_EVENT_ATTRIBUTE_DETAILS_URL, params);
        return response.parsedResponse;
    }

    public async updateEventAttribute(params: IEventAttributeRequestDAO & { eventAttributeId: number }): Promise<IEventAttributeDetailsDTO> {
        const response = await this.apiClient.put<IEventAttributeDetailsDTO>(GET_EVENT_ATTRIBUTE_DETAILS_URL, params);
        return response.parsedResponse;
    }

    public async deleteEventAttribute(params: { accountId: number; eventAttributeId: number }): Promise<void> {
        await this.apiClient.delete(GET_EVENT_ATTRIBUTE_DETAILS_URL, params);
    }

    private replaceFilterRequestParamsWithString(params: object, inputTypes?: EventAttributeTypesValues[]): object {
        return inputTypes?.length ? { ...params, inputTypes: inputTypes.join(',') } : params;
    }
}

export { AttributesDAO };